import { putDataToServer } from '../../../util';

export class TrmUpload {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  confirmDiscardTypologies = async (payload, type) => {
    let url = `${this.baseURL}/typologies?`;
    const { data } = payload || {};
    let ids = '';
    let action;
    data.forEach((obj) => {
      url += `ids=${String(obj.id)}&`;
    });
    if (type === 'CONFIRM') {
      url += 'action=Confirm';
    } else {
      url += 'action=Discard';
    }

    const params = {};
    const response = await putDataToServer(url, this.httpHeaders, params);
    if (response.status !== 200 && response.status !== 202) {
      throw Error(response.data.message);
    } else {
      return response.data;
    }
  };

  confirmTRMUpload = async (payload) => {
    return await this.confirmDiscardTypologies(payload, 'CONFIRM');
  };
  discardTRMUpload = async (payload) => {
    return await this.confirmDiscardTypologies(payload, 'DISCARD');
  };
}
